import { z } from 'zod/v4';
import { createFunctionSchema } from './zod.js';
export const AwsSecretSchema = z.object({
    AccessKeyId: z.string(),
    SecretAccessKey: z.string(),
    SessionToken: z.string(),
    Expiration: z.string(),
    Region: z.string(),
});
export const CredentialsProviderSchema = createFunctionSchema(z.tuple([]), z.promise(AwsSecretSchema));
//# sourceMappingURL=awsSecret.js.map